import React from "react";
import Footer from "../footer";
import "./main.css";
import "/node_modules/bootstrap/dist/css/bootstrap.min.css";

import roo from "../Assets/Avit-Resume.pdf";
import Avbar from "../navbar/Navbar";

function Resume() {
  return (
    <>
      <Avbar />
      <div className="divv" style={{
        height: "calc(var(--vh, 1vh) * 75)",
        width: "100%",
      }}>




        <h1>My Resume</h1>


        <embed src={roo} width="50%" height="100%" />

        <form method="get" action={roo}>

          <button class="btn"><i class="fa fa-download"></i> Download</button>
        </form>

      </div>
      <Footer />
    </>
  );
}

export default Resume;
